import { z } from 'zod';
/**
 * Avisos de outros apps (só Android, só com a permissão de acesso a notificações
 * ligada pela pessoa). O aparelho lê quem escreveu e o texto das mensagens dos
 * apps da lista; nada é guardado nem sai do aparelho sem um pedido explícito do
 * dono (a sugestão de resposta e a voz). A resposta vai pela ação do próprio aviso.
 */
/** Apps de mensagem que o ouvinte considera; qualquer outro é ignorado. */
export const INBOX_APPS = {
    'com.whatsapp': 'WhatsApp',
    'com.whatsapp.w4b': 'WhatsApp Business',
    'org.telegram.messenger': 'Telegram',
    'org.thoughtcrime.securesms': 'Signal',
    'com.instagram.android': 'Instagram',
    'com.facebook.orca': 'Messenger',
    'com.google.android.apps.messaging': 'Mensagens',
    'com.samsung.android.messaging': 'Mensagens',
};
export const inboxItemSchema = z.object({
    /** Chave do aviso no Android (muda a cada aviso). */
    key: z.string().min(1).max(300),
    pkg: z.string().min(1).max(120),
    app: z.string().min(1).max(40),
    from: z.string().min(1).max(120),
    text: z.string().min(1).max(2000),
    /** Quando chegou (ms desde 1970). */
    at: z.number().int(),
    /** O aviso aceita resposta por dentro (campo de texto do próprio aviso). */
    canReply: z.boolean(),
    /** As falas recebidas desde a última resposta da pessoa (até 6), na ordem. */
    lines: z
        .array(z.object({ text: z.string().min(1).max(2000), at: z.number().int() }))
        .max(10)
        .optional(),
    /** A última fala da conversa é da própria pessoa (respondeu pelo aviso do outro app). */
    mine: z.boolean().optional(),
    /** Assinatura das falas (só para o aparelho saber o que mudou). */
    sig: z.string().max(2000).optional(),
});
/** Pedido de sugestão de resposta (fase 2): só o texto daquele aviso, naquele momento. */
export const inboxDraftRequestSchema = z.object({
    app: z.string().trim().min(1).max(40),
    from: z.string().trim().min(1).max(120),
    text: z.string().trim().min(1).max(2000),
});
export const inboxDraftResultSchema = z.object({ text: z.string().max(600) });
/** Ferramentas da voz que rodam no aparelho (como as de tela): o servidor só as declara. */
export const INBOX_LIST_TOOL = 'ver_notificacoes';
export const INBOX_REPLY_TOOL = 'responder_notificacao';
